/* --- QUESTIONNAIRE CONFIG --- */

export interface QuestionnaireMIAHCD {
  position: number;
  question: string;
  answers: string[];
}

export const Q_MIAH_CD: QuestionnaireMIAHCD[] = [
  {
    // tslint:disable-next-line:max-line-length
    position: 1, question: 'Se dovesse misurare il Suo stato di salute generale attribuendo un numero, quale numero sceglierebbe? (0=malissimo, 10=perfetto)' ,
    answers: [
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '10'
    ]
  },
  {
    position: 2, question: 'Sanguinamento rettale:',
    answers: [
      'Sì',
      'No'
    ]
  },
  {
    position: 3, question: 'Perdita di muco:',
    answers: [
      'Sì',
      'No'
    ]
  },
  {
    position: 4, question: 'Numero di evacuazioni al giorno:',
    answers: null
  },
  {
    position: 5, question: 'Urgenza evacuativa:',
    answers: [
      'No',
      'Sì, urgente',
      'Sì, molto urgente'
    ]
  },
  {
    position: 6, question: 'Astenia' ,
    answers: [
      '1',
      '2',
      '3',
      '4',
      '5',
      '6',
      '7',
      '8',
      '9',
      '10'
    ]
  }
];

/* ------------ RESULTS CONFIGURATION + CONSTRUCTOR ------------ */

export class MIAHCDResults {
  patientSSN: string;
  doctorID: string;
  results: string[];
  finalScore: number;

  constructor(doctorID: string, patientSSN: string, results: string[], finalScore: number) {
    this.doctorID = doctorID;
    this.patientSSN = patientSSN;
    this.results = results;
    this.finalScore = finalScore;
  }

}
